<template>
  <div class="page-layout users">

    <!-- aboutus intro -->
    <section class="heroSection">
      <b-container fluid>
        <b-row class="intro-section">
          <b-col xl="12" lg="12" md="12">
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>أضف إستشارتك </b></h1>
                <p>يستقبل تَخَطّي كافة الإستشارات التى تتعلق بالمشكلات والإضطرابات النفسية والسلوكية والزوجية، ومشكلات
                  الإدمان، ومشكلات الأطفال والمراهقين.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-alert :show="alertCountdown" dismissible fade :variant="alertType" @dismiss-count-down="countDownChanged">
      {{ alertText }}
    </b-alert>

    <div class="text-center text-danger my-2" v-show="pageIsLoading">
      <b-spinner class="align-middle"></b-spinner>
    </div>

    <!-- greyBox -->
    <section class="greyBox">
      <b-container fluid>
        <b-row class="">
          <b-col xl="12" lg="12" md="12" style="text-align: right;">
            <div class="text-section">
              <div>
                <div class="title">
                  <h2 class="name">
                    أضف إستشارتك
                  </h2>
                </div>
                <p style="text-align: right;">
                  أخبرنا إذا كان لديك سؤال أو تريد ترك تعليق أو تريد المزيد من المعلومات حول التخطي.
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-form @submit.stop.prevent="onSubmit">
      <b-container class="bv-example-row" style="text-align: right;">
        <div class="mb-3">
          <h5><b></b></h5>
        </div>
        <b-row class="mb-3 pt-3 pb-3 mx-0 pr-2 pl-2 form-section" v-show="pageIsLoading">
          <b-col lg="12" md="12">
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-3 pt-3 pb-3 mx-0 pr-2 pl-2 form-section" v-show="!pageIsLoading">

          <b-col lg="6" md="12">
            <b-form-group id="group-form-name" :label="'الاسم (لن يظهر)'" label-for="form-name">
              <b-form-input autofocus id="form-name" name="form-name" v-model="$v.form.name.$model"
                :state="validateState('name')" aria-describedby="input-edit-name"></b-form-input>
              <b-form-invalid-feedback id="input-edit-name" v-if="!$v.form.name.required">
                {{ "الاسم مطلوب" }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="input-edit-name" v-if="!$v.form.name.namePattern">
                الاسم يجب أن يكون بين 2 إلى 30 حرفًا فقط بدون رموز أو أرقام
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col lg="6" md="12">
            <b-form-group id="group-form-email" :label="'البريد الالكتروني'" label-for="form-email">
              <b-form-input id="form-email" name="form-email" v-model="$v.form.email.$model"
                :state="validateState('email')" aria-describedby="input-edit-email"></b-form-input>
              <b-form-invalid-feedback id="input-edit-email" v-if='!$v.form.email.required'>
                {{ "البريد الالكتروني مطلوب" }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="input-edit-email" v-if='!$v.form.email.email'>
                {{ "البريد الالكتروني غير صالح" }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col lg="6" md="12">
            <b-form-group id="group-form-country" :label="'البلد'" label-for="form-country">
              <b-form-select id="group-form-country" label-for="form-country" name="form-country"
                v-model="$v.form.country.$model" :state="validateState('country')"
                aria-describedby="input-edit-country">
                <option v-for="s in countries" :key="s.name" :value="s.name">
                  {{ s.name }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback id="input-edit-country" v-if='!$v.form.country.required'>
                {{ "البلد مطلوبة" }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col lg="6" md="12">
            <b-form-group id="group-form-subject" :label="'الموضوع'" label-for="form-subject">
              <b-form-input id="form-subject" name="form-subject" v-model="$v.form.subject.$model"
                :state="validateState('subject')" aria-describedby="input-edit-subject"></b-form-input>
              <b-form-invalid-feedback id="input-edit-subject" v-if='!$v.form.subject.required'>
                {{ "الموضوع مطلوب" }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col lg="12" md="12">
            <b-form-group id="group-form-message" :label="'محتوى الاستشارة'" label-for="form-message">
              <b-form-textarea rows="5" id="form-message" name="form-message" v-model="$v.form.message.$model"
                :state="validateState('message')" aria-describedby="input-edit-message"></b-form-textarea>
              <b-form-invalid-feedback id="input-edit-message" v-if='!$v.form.message.required'>
                {{ "المحتوى مطلوب" }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="input-edit-message" v-if='!$v.form.message.minLength'>
                {{ "اكثر من 10 احرف" }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col lg="12" md="12">
            <b-button class="px-5" type="submit" variant="primary">{{ "ارسال" }}</b-button>
          </b-col>

        </b-row>
      </b-container>
    </b-form>
  </div>
</template>


<script>
import { validationMixin } from "vuelidate";
import { required, email, url, numeric, minLength, maxLength, minValue, maxValue } from "vuelidate/lib/validators";
import { sendRequest } from '../utils/RequestHelper.js'
import { sendContactFormEmail, isContactEmailConfigured } from '../utils/contactEmail.js'
const namePattern = (value) => /^[A-Za-z\u0600-\u06FF]{2,30}$/.test(value);

export default {
  mixins: [validationMixin],
  data() {
    return {
      pageIsLoading: false,
      alertCountdown: 0,
      alertType: '',
      alertText: '',
      form: {
        name: null,
        country: null,
        email: null,
        subject: null,
        message: null
      },
      countries: []
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(10),
        namePattern
      },
      email: {
        required,
        email
      },
      country: {
        required,
      },
      subject: {
        required
      },
      message: {
        required,
        minLength: minLength(10)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    countDownChanged(alertCountdown) {
      this.alertCountdown = alertCountdown
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.createItem();
    },
    backToHome(status) {
      this.$router.push({
        name: 'clients',
        query: {
          message: status
        }
      })
    },
    createItem() {
      if (!isContactEmailConfigured()) {
        this.$bvToast.toast(
          'أضف VUE_APP_WEB3FORMS_ACCESS_KEY في .env ثم أوقف السيرفر (Ctrl+C) وأعد تشغيل npm run serve — التعديل على .env لا يُطبَّق قبل إعادة التشغيل.',
          {
            title: 'الاستشارة',
            variant: 'warning',
            solid: true,
            noCloseButton: true,
          }
        );
        return;
      }
      this.pageIsLoading = true;
      sendContactFormEmail({
        name: this.form.name,
        email: this.form.email,
        country: this.form.country,
        subject: this.form.subject,
        message: this.form.message,
      })
        .then(() => {
          this.form.email = null;
          this.form.message = null;
          this.form.name = null;
          this.form.country = null;
          this.form.subject = null;
          this.$v.form.$reset();
          this.$bvToast.toast('تم الارسال بنجاح!', {
            title: 'الاستشارة',
            variant: 'success',
            solid: true,
            noCloseButton: true,
          });
        })
        .catch(() => {
          this.$bvToast.toast('حدث خطأ ما', {
            title: 'الاستشارة',
            variant: 'danger',
            solid: true,
            noCloseButton: true,
          });
        })
        .finally(() => {
          this.pageIsLoading = false;
        });
    },
    getCountries() {
      this.pageIsLoading = true;
      sendRequest('get', 'Countries', false, null,
        (response) => {
          this.pageIsLoading = false;
          this.countries = response.data.data;
        },
        () => {
          this.pageIsLoading = false;
          this.alertType = 'danger';
          this.alertText = 'حدث خطأ ما';
        }
      );
    },
  },
  created() {
    this.getCountries();
  }
};
</script>

<style scoped>
.heroSection .intro-section {
  background-image: url(../assets/images/heroGreenBG.png);
  background-size: cover;
  background-position: center;
  width: auto;
  height: 350px !important;
  color: white;
}

.heroSection .text-section {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 350px !important;
  align-items: center;
}

.heroSection .text-section h2 {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}



/* greyBox */
.greyBox {
  padding: 50px 40px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px 30px;
  font-size: 20px;
  width: 100%;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.greyBox .text-section .pref {
  font-size: 16px;
  color: #858585;
}
</style>